module.exports = __webpack_public_path__ + "img/ic_plus_blue.16ea2017.svg";